import axios from 'config/axiosConfig'
import setFilters from 'config/filters'
import { app_auth } from 'keys/apis'
import { convertArrayToIdsString } from 'utils/formatter'
import { getCurrentSchoolYear } from 'utils/general'

export const getUsersFetch = (params) => {
    const nParams = setFilters(params)
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/`, {
        params: nParams
    })
}

export const getUserFetch = (id) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_lookup/${id}/get_user_details/`)
}

export const getAffiliationTeamFetch = (params, id) => {
    let filters = setFilters(params)
    if (params.affiliation)
        filters.affiliation = params.affiliation
    if (params.roles?.length)
        filters.roles = convertArrayToIdsString(params.roles)
    if (params.grade)
        filters.grade = params.grade?.id || params?.grade
    if (params.school_class)
        filters.school_class = params.school_class?.id || params?.school_class
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_roles/get_affiliation_team/`, {
        params: {
            ...filters,
            school_year: getCurrentSchoolYear()
        }
    })
}

export const getAffiliationsTeamFetch = (params) => {
    let filters = setFilters(params)
    let nParams = { ...params, ...filters }

    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_roles/get_affiliation_user_roles/`, {
        params: nParams
    })
}

export const getUserDataFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_roles/get_user_roles/`)
}

export const getUserRolesFetch = (params) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_roles/get_user_roles2/`, {
        params: {
            ...params,
            school_year: getCurrentSchoolYear()
        }
    })
}

export const getUsersOptionsFetch = (params) => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/options/`, {
        params: params
    })
}

export const getRolesFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}roles/`)
}

export const getTranscriptionUsersFetch = () => {
    return axios.get(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_roles/get_transcription_users/`)
}

export const searchUserByTzFetch = (tz) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_lookup/search_by_tz/`, {
        tz
    })
}

export const updateUserBalanceFetch = async (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/update_balance/`, {
        ...values
    })
}

export const sendUserDetailsEmailFetch = async (id) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/${id}/send_details_email/`)
}

export const updateDefaultUserRolesFetch = async (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_me/update_default_roles/`, {
        default_user_roles: values
    })
}

export const updateUserStatusFetch = ({ id, status }) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/${id}/update_status/`, {
        status
    })
}

export const registerSchoolFetch = async (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/register_school/`, {
        ...values
    })
}

export const createCustomUserFetch = async (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user/create_user/`, {
        ...values
    })
}

export const updateCustomUserFetch = async (values) => {
    return axios.post(`${process.env.REACT_APP_SERVER_PORT}${app_auth}custom_user_lookup/${values.id}/update_user/`, {
        ...values
    })
}